module.exports = __webpack_public_path__ + "img/no-exams-data.961666b5.svg";